import styled from '@emotion/styled'
import { Button } from '@vivaldis/antd-ui'
import { useTheme } from '@vivaldis/ui'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState } from '../../../EmptyState'
import { Step, useStep } from '../../provider/StepProvider'
import errorStateImageSrc from './assets/errorStateImage.svg'

interface Props {}

export const OcrFailedStep: FC<Props> = () => {
  const [t] = useTranslation('web_ui')
  const theme = useTheme()

  const { step, setStep } = useStep()
  const handleTryAgainButtonClick = useCallback(() => {
    setStep(Step.UploadIdDocumentStep)
  }, [setStep])

  const handleGoToEditManuallyButtonClick = useCallback(() => {
    setStep(Step.EditManuallyStep)
  }, [setStep])

  if (step !== Step.OcrFailedStep) {
    return null
  }

  return (
    <Base>
      <EmptyState
        title={
          <EmptyState.Title color={theme.red6}>
            {t(
              'edit_employee_personal_information_form.steps.ocr_failed.title'
            )}
          </EmptyState.Title>
        }
        caption={t(
          'edit_employee_personal_information_form.steps.ocr_failed.description'
        )}
        image={errorStateImageSrc}
        action={
          <ActionsBase>
            <Button
              onClick={handleTryAgainButtonClick}
              type="primary"
              shape="round"
              size="large"
            >
              {t(
                'edit_employee_personal_information_form.steps.ocr_failed.try_again_button'
              )}
            </Button>
            <Button
              onClick={handleGoToEditManuallyButtonClick}
              type="default"
              shape="round"
              size="large"
            >
              {t(
                'edit_employee_personal_information_form.steps.ocr_failed.go_to_edit_manually_button'
              )}
            </Button>
          </ActionsBase>
        }
      />
    </Base>
  )
}

const Base = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
`

const ActionsBase = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
`
